import { CldPictureComponent } from '@shared/components/cld-picture/cld-picture.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailsRoutingModule } from './product-details-routing.module';
import { ProductDetailsComponent } from './product-details.component';
import { MatCardModule } from '@angular/material/card';
import { ProductBySlugGQL } from '@shared/services/products/graphql/product-by-slug.gql.service';
import { ProductDetailsResolver } from './product-details.resolver';
import {IvyCarouselModule} from 'ngx-ivy-responsive-carousel'
import { ShareModule } from 'ngx-sharebuttons';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { ExpShareButtonsModule } from 'app/shared/components/exp-share-buttons/exp-share-buttons.module';


import { ResizeVideoUrlPipe } from 'app/shared/pipes/resize-video-url';

import { UpdateViewsProductCounterGQL } from 'app/shared/services/products/graphql/update-views-product-counter.gql.service';
import { ProductRequestComponent } from 'app/stand/components/product-request/product-request.component';
import { ProductRatingComponent } from './product-rating/product-rating.component';
import { ProductsComponent } from '../products/products.component';


@NgModule({
    imports: [
    CommonModule,
    MatCardModule,
    MatToolbarModule,
    ProductDetailsRoutingModule,
    IvyCarouselModule,
    ShareModule,
    MatIconModule,
    ExpShareButtonsModule,
    CldPictureComponent,
    ResizeVideoUrlPipe,
    ProductRequestComponent,
    ProductRatingComponent,
    ProductsComponent,
    ProductDetailsComponent
],
    providers: [
        ProductBySlugGQL,
        ProductDetailsResolver,
        UpdateViewsProductCounterGQL
    ]
})
export class ProductDetailsModule { }
